import { create } from "zustand";
import type { ModuleId } from "@/modules";

export interface VeilRect {
  top: number;
  left: number;
  width: number;
  height: number;
  /** Kartın köşe yarıçapı (px) — perde karttan "büyürken" aynı köşeyle başlar. */
  radius: number;
}

export type VeilPhase =
  /** Perde kart boyutundan tam ekrana büyüyor. */
  | "expanding"
  /** Tam ekran; hedef route yüklenip konum değişince açılacak. */
  | "expanded"
  /** Yeni sayfa altında, perde çekiliyor. */
  | "revealing";

export interface ModuleVeil {
  moduleId: ModuleId;
  hue: number;
  /** Perde tam ekran olduğunda gidilecek adres (path ya da tam URL). */
  href: string;
  rect: VeilRect;
  phase: VeilPhase;
}

interface ModuleTransitionStore {
  veil: ModuleVeil | null;
  startVeil: (veil: Omit<ModuleVeil, "phase">) => void;
  setPhase: (phase: VeilPhase) => void;
  clearVeil: () => void;
  /**
   * Hover'daki modül — 3D sahne (Canvas root) ile DOM etiketleri/tile'lar
   * ayrı React ağaçlarında olduğu için local state yerine burada paylaşılır.
   */
  hoveredId: ModuleId | null;
  setHoveredId: (id: ModuleId | null) => void;
}

/**
 * Hub kartı → modül geçişindeki tam ekran "perde" durumu.
 *
 * Perde AppRoot'ta yaşar (route değişiminde unmount olmaz); hub sayfası
 * yalnızca başlatır. Navigasyon ve kapanış perdenin kendisinde.
 */
export const useModuleTransitionStore = create<ModuleTransitionStore>()(
  (set) => ({
    veil: null,
    startVeil: (veil) => set({ veil: { ...veil, phase: "expanding" } }),
    setPhase: (phase) =>
      set((s) => (s.veil ? { veil: { ...s.veil, phase } } : s)),
    clearVeil: () => set({ veil: null }),
    hoveredId: null,
    setHoveredId: (hoveredId) => set({ hoveredId }),
  }),
);
